import { Title, Text, Button } from 'components';
import React from 'react';
import { ReactComponent as Empty } from './empty.svg';
import { BottomBar, CartEmptySubtitle, EmptyCartContainer } from './EmptyCart.style';

export type CartProps = {
    navigate: () => void;
};

const EmptyCart: React.FunctionComponent<CartProps> = ({ navigate }) => {
    return (
        <>
            <EmptyCartContainer>
                <Empty />
                <Title text={'cartEmpty'} />
                <CartEmptySubtitle text={'cartEmptySubtitle'} />
            </EmptyCartContainer>
            <BottomBar>
                <Button fullWidth onClick={navigate}>
                    <Text text={'cartEmptyCTA'} weight="bold" />
                </Button>
            </BottomBar>
        </>
    );
};

export default EmptyCart;
